import React from 'react'

const Bundles = () =>
    <div className="container u-margin-top" id="bundles">
        <div className="row u-justify-center">
        {
            bundles.map((bundle, i) =>
                <div
                    key={i}
                    className="col-12 col-md-6 col-lg-4 u-z--1"
                >
                    <a
                        href={bundle.href + bundle.query}
                        target="_blank"
                        className="optionbox scale-down-center"
                        onClick={() => {
                            if (window.s_gi && window.s_dtm) {
                                let s = s_gi('wmg,wmggbglobal,wmgprl,wmgprlgb,wmgkanomusic.com')
                                s_dtm.linkTrackVars='prop1,eVar4'
                                s_dtm.prop1 = 'Kano'
                                s_dtm.eVar4 = 'Kano'
                                s_dtm.tl(this,'o',`Kano:Hoodies All Summer Pre-order:Landing:${bundle.name} Image Click`)
                            }
                        }}
                    >
                        <img
                            src={bundle.img}
                            alt={bundle.name}
                            className="optionbox__image"
                        />
                        <div className="optionbox__name">{bundle.name}</div>
                    </a>
                </div>
            )
        }
        </div>
    </div>

export default Bundles

const bundles = [
    {
        name: 'Download and Stream',
        href: 'https://Parlophone.lnk.to/HoodiesAllSummer',
        query: '',
        img: 'img/Kano_Bundles_10.png'
    },
    // {
    //     name: 'Ultimate Bundle',
    //     href: 'https://smarturl.it/KA.Ultimate',
    //     query: '?intcmp=190718/kano/wmi/lan/s_pr/img/bdy/ww/hoodies-all-summer-pre-order-ultimate-bundle',
    //     img: 'img/Kano_Bundles_01.png'
    // },
    // {
    //     name: 'Vinyl and Print',
    //     href: 'https://smarturl.it/KA.VinylPrint',
    //     query: '?intcmp=190718/kano/wmi/lan/s_pr/img/bdy/ww/hoodies-all-summer-pre-order-vinyl-and-print',
    //     img: 'img/Kano_Bundles_03.png'
    // },
    // {
    //     name: 'CD and Print',
    //     href: 'https://smarturl.it/KA.CDPrint',
    //     query: '?intcmp=190718/kano/wmi/lan/s_pr/img/bdy/ww/hoodies-all-summer-pre-order-cd-and-print',
    //     img: 'img/Kano_Bundles_02.png'
    // },
    // {
    //     name: 'Hoodie, Vinyl and Print',
    //     href: 'https://smarturl.it/KA.Vinyl.HoodiePrint',
    //     query: '?intcmp=190718/kano/wmi/lan/s_pr/img/bdy/ww/hoodies-all-summer-pre-order-hoodie-vinyl-and-print',
    //     img: 'img/Kano_Bundles_07.png'
    // },
    // {
    //     name: 'Hoodie, CD and Print',
    //     href: 'https://smarturl.it/KA.CD.Hoodie.Print',
    //     query: '?intcmp=190718/kano/wmi/lan/s_pr/img/bdy/ww/hoodies-all-summer-pre-order-hoodie-cd-and-print',
    //     img: 'img/Kano_Bundles_06.png'
    // },
    // {
    //     name: 'Hoodie and Vinyl',
    //     href: 'https://smarturl.it/KA.Vinyl.Hoodie',
    //     query: '?intcmp=190718/kano/wmi/lan/s_pr/img/bdy/ww/hoodies-all-summer-pre-order-hoodie-and-vinyl',
    //     img: 'img/Kano_Bundles_05.png'
    // },
    // {
    //     name: 'Hoodie and CD',
    //     href: 'https://smarturl.it/KA.CD.Hoodie',
    //     query: '?intcmp=190718/kano/wmi/lan/s_pr/img/bdy/ww/hoodies-all-summer-pre-order-hoodie-and-cd',
    //     img: 'img/Kano_Bundles_04.png'
    // },
    {
        name: 'Vinyl',
        href: 'https://Parlophone.lnk.to/HASVinyl',
        query: '?intcmp=190718/kano/wmi/lan/s_pr/img/bdy/ww/hoodies-all-summer-pre-order-vinyl',
        img: 'img/Kano_Bundles_08.png'
    },
    {
        name: 'CD',
        href: 'https://Parlophone.lnk.to/HASCD',
        query: '?intcmp=190718/kano/wmi/lan/s_pr/img/bdy/ww/hoodies-all-summer-pre-order-cd',
        img: 'img/Kano_Bundles_09.png'
    }
]
